// /*********************
//  * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
//  * __________________
//  *
//  *  Mobillor Technologies Pvt. Ltd.
//  *  All Rights Reserved.
//  *
//  * NOTICE:  All information contained herein is, and remains
//  * the property of Mobillor Technologies Pvt. Ltd.
//  * The intellectual and technical concepts contained
//  * herein are proprietary to Mobillor Technologies Pvt. Ltd.
//  * may be covered by Rebublic Of India and Foreign Patents,
//  * patents in process, and are protected by trade secret or copyright law.
//  * Dissemination of this information or reproduction of this material
//  * is strictly forbidden unless prior written permission is obtained
//  * from Mobillor Technologies Pvt. Ltd.
//  */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

// Store
import { TabPanel, TabView } from "primereact/tabview";
import { getSubModulesByRoleId } from "../../store";

// Feature tabs
import AcceptPo from "./accecpt-purchase-order";
import RejectedPO from "./rejected-purchase-order";
import CreatePO from "./view-purchase-order";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const PurchaseOrder = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  const loginDetails = cookies.get("loginDetailsForWMS");
  const jwtToken = loginDetails?.jwt;
  const roleId = loginDetails?.data?.roleId;
  const roleName = loginDetails?.data?.roleName;

  const vendorRolePattern = /vendor/i;
  const isVendor = vendorRolePattern.test(roleName);

  useEffect(() => {
    if (roleId && jwtToken) {
      getSubModulesByRoleId(roleId, jwtToken);
    }
  }, [roleId, jwtToken, getSubModulesByRoleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    const data = getSubModulesByRoleIdReducer?.subModulesByRoleData?.data ?? [];
    setModulesData(Array.isArray(data) ? data : []);
  }, [getSubModulesByRoleIdReducer]);

  const CREATE_OR_PUBLISHED_PO_ID = "84718389-a2fb-427c-a13c-ef5db6e504ab";
  const ACCEPTED_PO_ID = "f5662ed5-ad46-4dbc-80ee-309b0e190546";
  const REJECTED_PO_ID = "0981180a-b90f-4288-8dab-e85776e28e16";

  const specialClientRoleId = "fd45b353-3270-459c-947e-d4921c590f41";

  const hasModule = (id) => modulesData?.some((m) => m?.moduleId === id);

  const createOrPublishedAccess = hasModule(CREATE_OR_PUBLISHED_PO_ID);
  const acceptedPOAccess = hasModule(ACCEPTED_PO_ID);
  const rejectedPOAccess = hasModule(REJECTED_PO_ID);

  const tabs = [];

  if (createOrPublishedAccess) {
    tabs.push({
      header: isVendor ? "Published PO" : "Created And Published PO",
      content: <CreatePO />,
    });
  }

  if (acceptedPOAccess) {
    tabs.push({
      header: "Accepted PO",
      content: <AcceptPo />,
    });
  }

  if (rejectedPOAccess) {
    tabs.push({
      header: "Rejected PO",
      content: <RejectedPO />,
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {tabs.length > 0 ? (
              <TabView>
                {tabs.map((tab, idx) => (
                  <TabPanel key={idx} header={tab.header}>
                    {tab.content}
                  </TabPanel>
                ))}
              </TabView>
            ) : (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No Purchase Order Access
              </h4>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrder);
